import React from "react";
import { Box, Chip, Typography, Card } from "@mui/material";
import * as MuiIcons from "@mui/icons-material";

const ALLOWED_PALETTE_KEYS = new Set([
  "primary",
  "secondary",
  "error",
  "warning",
  "info",
  "success",
]);

const normalizePaletteKey = (value, fallback = "secondary") => {
  const key = String(value || "").toLowerCase().trim();
  if (key === "inherit") return fallback;
  return ALLOWED_PALETTE_KEYS.has(key) ? key : fallback;
};

const StatusFilterCards = ({
  statuses = [],
  statusCounts = {},
  activeFilters = [],
  onToggle,
}) => {
  const pageCardSx = {
    borderRadius: "18px",
    border: "1px solid rgba(47,99,173,0.08)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    backgroundColor: "rgba(255,255,255,0.96)",
  };

  return (
    <Card sx={{ ...pageCardSx, p: { xs: 1.5, sm: 2, md: 2.25 }, mb: 3 }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#223142",
            mb: 0.5,
          }}
        >
          Filter by Status
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#6b778c",
          }}
        >
          Select one or more statuses to narrow down the results.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {statuses.map((status) => {
          const Icon = MuiIcons[status.icon] || MuiIcons.InfoOutlined;
          const count = statusCounts[status.statusname] || 0;
          const isActive = activeFilters.includes(status.statusname);
          const paletteKey = normalizePaletteKey(status.color, "secondary");

          return (
            <Chip
              key={status.id}
              label={`${status.statusname} (${count})`}
              icon={<Icon />}
              onClick={() => onToggle(status.statusname)}
              variant={isActive ? "filled" : "outlined"}
              sx={{
                cursor: "pointer",
                fontWeight: 700,
                borderRadius: "999px",
                height: 36,
                transition: "all 0.2s ease",
                ...(isActive
                  ? {
                      color: "#fff",
                      backgroundColor: (theme) =>
                        theme.palette[paletteKey]?.main,
                      borderColor: "transparent",
                      "& .MuiChip-icon": {
                        color: "#fff",
                      },
                    }
                  : {
                      color: "#223142",
                      borderColor: "rgba(47,99,173,0.14)",
                      backgroundColor: "rgba(255,255,255,0.96)",
                      "& .MuiChip-icon": {
                        color: (theme) => theme.palette[paletteKey]?.main,
                      },
                      "&:hover": {
                        backgroundColor: (theme) =>
                          theme.palette[paletteKey]?.main,
                        color: "#fff",
                        borderColor: "transparent",
                        "& .MuiChip-icon": {
                          color: "#fff",
                        },
                      },
                    }),
              }}
            />
          );
        })}
      </Box>
    </Card>
  );
};

export default StatusFilterCards;
